module.exports = __webpack_public_path__ + "img/8694c17.svg";